import * as React from 'react';
import { Label } from 'task-manager/TaskFilters.styles';
import {
  handleBackwardsCompatibilityWithCommaSeparatedJobTypes,
  handleUndefinedFilter,
} from './utils';
import { TaskType } from 'task-manager/types';
import { formatScreamingSnakesToPrettyStrings } from 'task-manager/formatScreamingSnakesToPrettyStrings';
import { ArrayParam, useQueryParam } from 'use-query-params';
import useV2Query from 'utils/useV2Query';
import { GET_TASK_TYPES } from 'task-manager/queries';

type TaskFilterProps = {
  handleSelectChange: (value: string | string[], name: string) => void;
};

export const TaskFilter = ({ handleSelectChange }: TaskFilterProps) => {
  const [taskTypes] = useQueryParam('taskTypes', ArrayParam);
  const [jobTypes] = useQueryParam('jobTypes', ArrayParam);
  const jobTypesVariable =
    jobTypes?.length && !jobTypes.some(type => type === undefined)
      ? handleBackwardsCompatibilityWithCommaSeparatedJobTypes(jobTypes)
      : undefined;
  const { data: taskTypesData } = useV2Query(GET_TASK_TYPES, {
    variables: { jobTypes: jobTypesVariable },
    skip: !jobTypesVariable,
  });

  return (
    <span key={'taskFilter'}>
      <Label>Task</Label>
      <select
        aria-label="taskTypes dropdown"
        name="taskTypes"
        value={handleUndefinedFilter(taskTypes)}
        onChange={({ target: { value, name } }) =>
          handleSelectChange(TaskType[value] ? [value] : value, name)
        }
        disabled={!taskTypesData?.taskTypes}
      >
        <option value={undefined}>All</option>
        {taskTypesData?.taskTypes.map((type, i) => (
          <option value={type} key={`${i}-${handleUndefinedFilter(taskTypes)}-${type}`}>
            {formatScreamingSnakesToPrettyStrings(type)}
          </option>
        ))}
      </select>
    </span>
  );
};
